export class ClaudeEnterpriseEntityFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "organizationId",
            "baseName": "organizationId",
            "type": "ClaudeEnterpriseOrganizationIdFilters",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ClaudeEnterpriseEntityFilters.attributeTypeMap;
    }
    constructor() {
    }
}
